export const HeaderNames = {
  XSRFToken: 'XSRF-TOKEN',
};
